import React from 'react';
import { trackPixelEvent } from './MetaPixel';
type CTAVariant = 'aura' | 'green';
interface CTAButtonProps {
  label: string;
  href?: string;
  className?: string;
  /** Overrides only the label sizing, so long labels can stay on a single line. */
  textClassName?: string;
  variant?: CTAVariant;
}
const variantClasses: Record<CTAVariant, string> = {
  aura: 'bg-aura text-white shadow-plum/25 focus-visible:outline-aura',
  green: 'cta-button--green bg-neon text-neon-ink shadow-neon/40 focus-visible:outline-neon'
};
export function CTAButton({
  label,
  href = '#comprar',
  className = '',
  textClassName = 'text-base sm:text-[17px]',
  variant = 'aura'
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith('http');
  return <a href={href} onClick={() => {
    if (goesToCheckout) trackPixelEvent('InitiateCheckout');
  }} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-[10px] px-4 py-4 text-center font-extrabold shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:px-6 ${variantClasses[variant]} ${textClassName} ${className}`} data-id="element-31" data-mp="2ys5x4eiillta">
      {label}
    </a>;
}